export default "__VITE_ASSET__CO1A5hWC__"